import React from "react";
import NumberPaginator from "./NumberPaginator";

const StepPaginator = (props) => {
  return <NumberPaginator {...Object.assign({}, props, { enableNumbers: false })} />;
};

export default StepPaginator;
